
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder';

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
    global: {
        fetch: (url, options) => {
            return fetch(url, {
                ...options,
                cache: 'no-store' // Prevents browser from caching API responses (avoids cross-tenant cache bleed)
            });
        }
    }
});
